<template>
  <PDFDocument style="text-align: center;" :name="$route.params.name" :fileLang="$route.params.lang" :key="updatePdf" />
</template>

<script>
import PDFDocument from '@/components/widgets/PDFDocument'
import langOps from '@/mixins/langOps'

export default {
  data () {
    return {
      updatePdf: 0
    }
  },
  components: {
    PDFDocument
  },
  mixins: [langOps],
  beforeRouteUpdate (to, from, next) {
    this.updatePdf += 1
    next()
  }
}
</script>
